const numberFormat = new Intl.NumberFormat('pt-BR')

function toReal (value) {
    return numberFormat.format(parseFloat(Math.trunc(value)))
}

function toKg (value) {
    return numberFormat.format(parseFloat(Math.trunc(value)))
}

export { toReal, toKg }